<div class="input-slider">
  @if (label()) {
    <mat-label
      class="input-slider__label"
      [class.input-slider__label--editable]="!showMode()"
    >
      @if (hint(); as hint) {
        <mat-icon
          class="input-slider__hint"
          [matTooltip]="hint"
        >
          info
        </mat-icon>
      }
      <div class="input-slider__label-text">
        {{ label() }}
      </div>
      @if (isRequired && !showMode()) {
        <span class="input-required"> * </span>
      }
    </mat-label>
  }
  @if (showMode()) {
    <div>
      {{ displayWith()(control().value) }}
    </div>
  } @else {
    <div class="input-slider__container">
      <mat-slider
        class="input-slider__item"
        discrete
        showTickMarks
        [disabled]="showMode()"
        [min]="min()"
        [step]="step()"
        [max]="max()"
        [displayWith]="displayWith()"
      >
        <input
          class="input-slider__input"
          matSliderThumb
          [formControl]="control()"
          (valueChange)="changed.emit($event)"
        />
      </mat-slider>
      <div class="input-slider__value">
        {{ displayWith()(control().value) }}
      </div>
    </div>
  }
</div>
